module.exports = __webpack_public_path__ + "static/choir2-b75ac1f4a531e1b8bdd1ce3a8258c109.jpg";